import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../../core/config/app.config';
import { AppConfigConstants } from '../../core/config/app.config.constants';

@Component({
  selector: 'ats-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  footerPrivacyStatementURL = AppConfig.appSetting(AppConfigConstants.FOOTER_PRIVACY_STATEMENT_URL);
  footerEmailNoticeURL = AppConfig.appSetting(AppConfigConstants.FOOTER_EMAIL_NOTICE_URL);
  footerDisclaimerURL = AppConfig.appSetting(AppConfigConstants.FOOTER_DISCLAIMER_URL);
  footerContactURL = AppConfig.appSetting(AppConfigConstants.FOOTER_CONTACT_URL);
  footerADAURL = AppConfig.appSetting(AppConfigConstants.FOOTER_ADA_URL);
  constructor() { }

  ngOnInit() {
  }

}
